var isdefined = function (arg) {
	return arg !== void 0 && arg !== null;
};

/**
 * @param p {string}       search class prefix to be removed
 * @return {boolean} true if an instance has been found
 * @private
 */
HTMLElement.prototype.cleanClasses = function(p){
	var
		newnames = [],
		names = (this.getAttribute('class') || '').split(' '),
		found = false
	;
	
	for(var n, i = 0, ilen = names.length; i < ilen; i++) {
		n = names[i].trim();
		if(n.indexOf(p) === 0) {
			found = true;
			continue;
		}
		newnames.push(n);
	}
	
	this.setAttribute('class', newnames.join(' '));
	
	return found;
};

var G;

if (!isdefined(G)) {
	G = {}; 
}

if (!isdefined(G.log)) {
	G.log = {
		hudSearch: {
			status: true,
			id: 'hudSearch'
		},
		model: {
			status: true,
			id: 'model'
		},
		alerts: {
			status: true,
			id: 'alerts'
		},
		navigationRouting: {
			status: false,
			id: 'navigationRouting'
		}
	};

	G.LOG = function (channel) {
		var args;
		if (G.log && channel.status) {
			args = Array.from(arguments);
			args[0] = '[' + channel.id + ']';
			console.log.apply(null, args);
		}
	}
}

if (!isdefined(G.config)) {
	G.config = {};

	G.config._GUID_COUNTER = 0;
	/**
	 * Returns a unique identifier ID (UIID).
	 * @return {string}
	 */
	G.config.GET_GUID = function () {
		++G.config._GUID_COUNTER;
		return 'guid' + G.config._GUID_COUNTER;
	};
	G.config.PRODUCTION = true;
	// G.config.LOAD_ALERTS = G.config.PRODUCTION || false;
	G.config.SERVER = '/';
	// G.config.SERVER = 'http://gv.preprod/';
	G.config.API = G.config.SERVER + 'backend/api/';
	G.config.APIGVALERTS = G.config.SERVER + 'apigv/alerts/';
	G.config.SYNOPTIQUE_API = G.config.SERVER + 'backend/synoptique/';
	G.config.SITE_PATH = window.location.origin + '/';
	G.config.REDIRECT_PATTERN = '/dashboard/gv';
	G.config.SECTION_BASE_URL = G.config.SITE_PATH + 'frontend/dashboard/gv';
	G.config.ALERTS_NUM_SIBLINGS = 12;
	G.config.SOCKET_IO_GIO = 'https://io-02.global-visio.com:22443';
	G.config.MM_PATH = '/';
	/** @type {G.vo.ResponsiveBreak[]} */
	G.config.RESPONSIVE_BREAKS = [
		{id: 'desktop-large-max', min: 1440},
		{id: 'desktop-max', min: 1200},
		{id: 'semi-desktop-max', min: 1100},
		{id: 'desktop', min: 962},
		{id: 'tablet', min: 768},
		{id: 'mobile', min: 0},
	];
}